module.exports = __webpack_public_path__ + "static/bach_1-9408f36706ee116873761768e088ca40.jpg";